import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, OnInit, Output } from '@angular/core';
import { AxsButtonComponent, AxsIconComponent } from '@vanguard/axs-angular';
import { ContentService } from 'src/app/shared/services/content/content.service';
import { content } from 'src/assets/content/fallback-content';

import { AdobeLaunchService } from '../../adobe-launch/adobe-launch.service';
import { ResearchSummaryModalComponent } from '../research-summary-modal/research-summary-modal.component';

@Component({
  selector: 'how-it-works-v4',
  standalone: true,
  imports: [CommonModule, AxsButtonComponent, AxsIconComponent, ResearchSummaryModalComponent],
  templateUrl: './how-it-works-v4.component.html',
  styleUrls: ['./how-it-works-v4.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HowItWorksComponent implements OnInit {
  howItWorksContent = content.Data.v4_rcc_root.content.howItWorksSection;
  needHelpContent = content.Data.v4_rcc_root.content.needHelp;
  isResearchSummaryModalOpen = false;
  readonly researchPaperLink = 'https://advisors.vanguard.com/content/dam/fas/pdfs/ISGBETR.pdf';
  readonly taxChartLink = 'https://advisors.vanguard.com/content/dam/fas/pdfs/FATXGD11.pdf';
  readonly researchPaperDownloadTag = 'ISGBETR:download full research paper overview body1';
  readonly taxChartDownloadTag = 'FATXGD11:download 2026 tax charts';

  @Output() useCalculator = new EventEmitter<void>();
  @Output() trySampleClient = new EventEmitter<void>();
  @Output() viewTermsAndDefinitions = new EventEmitter<void>();
  @Output() openBreakEvenTaxRate = new EventEmitter<void>();

  constructor(
    private readonly adobeLaunchService: AdobeLaunchService,
    private readonly contentService: ContentService,
  ) {}

  ngOnInit(): void {
    this.contentService.getContent().subscribe((data) => {
      this.howItWorksContent = data.Data.v4_rcc_root.content.howItWorksSection;
      this.needHelpContent = data.Data.v4_rcc_root.content.needHelp;
    });
  }

  downloadResearch(): void {
    this.adobeLaunchService.captureCtaLink('read-a-summary-of-our-research');
    this.isResearchSummaryModalOpen = true;
  }

  onUseCalculator(): void {
    this.adobeLaunchService.captureCtaButton('use-the-calculator-body1');
    this.useCalculator.emit();
  }

  onTrySampleClient(): void {
    this.adobeLaunchService.captureCtaButton('try-sample-client-body1');
    this.trySampleClient.emit();
  }

  onViewTermsAndDefinitions(): void {
    this.adobeLaunchService.captureCtaLink('view-terms-and-definitions-body1');
    this.viewTermsAndDefinitions.emit();
  }

  onOpenBreakEvenTaxRate(): void {
    this.adobeLaunchService.captureCtaLink('overview:better-even-tax-rate');
    this.openBreakEvenTaxRate.emit();
  }

  openResearchPaper(event: Event): void {
    event.preventDefault();
    this.adobeLaunchService.downloadAction(this.researchPaperDownloadTag);
    window.open(this.researchPaperLink, '_blank', 'noopener,noreferrer');
  }

  openTaxChart(event: Event): void {
    event.preventDefault();
    this.adobeLaunchService.downloadAction(this.taxChartDownloadTag);
    window.open(this.taxChartLink, '_blank', 'noopener,noreferrer');
  }
}
